/**
 * Hydration timing — measures time from first JS execution to hydrateRoot() completion.
 */
import { reportWebHydrationMs } from '@/shared/lib/metrics/client-metrics_gen';
import { pageLabel } from '@/shared/lib/metrics/page-label';

export function reportHydration(startMs: number): void {
  const duration = performance.now() - startMs;
  // Closed `page` section (round-5 K4) — see page-label.ts.
  reportWebHydrationMs(duration, { page: pageLabel(location.pathname) });
}
